import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const links = [{
  label: 'About',
  id: 'about'
}, {
  label: 'Experience',
  id: 'week'
}, {
  label: 'Destinations',
  id: 'locations'
}, {
  label: 'Join',
  id: 'waitlist'
}];
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
    setOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-paper/90 backdrop-blur-md border-b border-ink/10' : 'bg-transparent'}`} data-id="element-84">
      <nav className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between" data-id="element-85">
        <button onClick={() => scrollTo('top')} aria-label="Home" className="brandmark" data-id="element-86">
          Courage Collective
        </button>

        <ul className="hidden md:flex items-center gap-10" data-id="element-87">
          {links.map(l => <li key={l.id} data-id="element-88">
              <button onClick={() => scrollTo(l.id)} className="eyebrow hover:!text-accent transition-colors" data-id="element-89">
                {l.label}
              </button>
            </li>)}
        </ul>

        <button className="md:hidden text-ink" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-id="element-90">
          {open ? <XIcon size={20} data-id="element-91" /> : <MenuIcon size={20} data-id="element-92" />}
        </button>
      </nav>

      {open && <div className="md:hidden bg-paper border-t border-ink/10 px-6 py-8" data-id="element-93">
          <ul className="flex flex-col gap-6" data-id="element-94">
            {links.map(l => <li key={l.id} data-id="element-95">
                <button onClick={() => scrollTo(l.id)} className="eyebrow !text-ink" data-id="element-96">
                  {l.label}
                </button>
              </li>)}
          </ul>
        </div>}
    </header>;
}